import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css', '../login/login.component.css']
})
export class ResetComponent implements OnInit{
  faEnvelope = faEnvelope;
  sent: boolean | null = null;
  submitted = false;
  resetPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required])
  });
  constructor(private http: HttpClient, private authService: AuthService, private router: Router, private title: Title) {

  }

  ngOnInit(): void {
      this.title.setTitle("Reset Password | Sviluppo Personale");
  }

  get email() {
    return this.resetPasswordForm.get('email');
  }
  public sendEmail() {
      this.submitted  = true;
      this.sent = null;
      this.authService.forgot_password(this.email?.value).subscribe({ next: res => {
        if(res['status']) this.sent = true;
        setTimeout(() => {
          window.close();
        }, 2000);
      }, error: e => {
        this.sent = false;
      }
    });
  }
}

